import React from 'react';
import { PanelTab as PanelTabNew } from './PanelTab';
import { convertOldPanelTabProps } from './converter.old';
import type { OldPanelTabProps } from './converter.old';

export type PanelTabProps = OldPanelTabProps;

export const PanelTab: React.FC<PanelTabProps> = (props) => <PanelTabNew {...convertOldPanelTabProps(props)} />;
